import { render } from "./Test.vue?vue&type=template&id=34a0a4b5"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"
script.render = render

export default script